import { setOptions, importLibrary } from '@googlemaps/js-api-loader'
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'

addEventListener('DOMContentLoaded', async () => {
  const mapContainer = document.getElementById('map')
  if (mapContainer) {
    setOptions({ key: mapContainer.getAttribute('data-api-key'), v: 'quarterly' })

    const { Map, InfoWindow } = await importLibrary('maps')
    const { AdvancedMarkerElement } = await importLibrary('marker')
    const { LatLngBounds } = await importLibrary('core')
    const json = await fetch(location.href, { headers: { 'Accept': 'application/json' } }).then(resp => resp.json())

    const map = new Map(mapContainer, { mapId: 'members-map' })
    const bounds = new LatLngBounds()

    const markers = json.map(({ latitude, longitude, names }) => {
      const position = { lat: latitude, lng: longitude }
      let marker = new AdvancedMarkerElement({ position, map })

      marker.addListener('gmp-click', () => {
        new InfoWindow({ content: names }).open({ anchor: marker, map, shouldFocus: false })
      })

      bounds.extend(position)
      return marker
    })

    map.fitBounds(bounds)
    new MarkerClusterer({ map, markers, algorithm: new SuperClusterAlgorithm({ radius: 100 }) })
  }
})
